import PropTypes from "prop-types"
import LogoHomeLink from "components/logo/home-link"
import ResourceName from "components/resource-name"
import ServerNotifications from "modules/server-notifications"
import HelpMenu from "modules/help-menu"
import ThemeModeToggle from "components/theme-mode-toggle"
import ContextualMenu from "components/contextual-menu"
import { KellyLauncherButton } from "connected-components/agent-chat/components/kelly-launcher-button"

import "./style.scss"

export default function Nav({ account, watchlistName, isLoading, modelId, menuItems }) {
  return <div className="watchlist-root-nav">
    <div className="left">
      <LogoHomeLink account={account} />
      <div className="watchlist-name"><ResourceName name={watchlistName} isLoading={isLoading} /></div>
      <ContextualMenu items={menuItems} />
    </div>
    <div className="right">
      <ServerNotifications />
      <HelpMenu modelId={modelId} />
      <ThemeModeToggle inline />
      <KellyLauncherButton />
    </div>
  </div>
}

Nav.propTypes = {
  account: PropTypes.string.isRequired,
  watchlistName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  modelId: PropTypes.string,
  menuItems: PropTypes.array,
}
